import { render } from "./AstronautGame.vue?vue&type=template&id=6d1d5586&scoped=true"
import script from "./AstronautGame.vue?vue&type=script&lang=js"
export * from "./AstronautGame.vue?vue&type=script&lang=js"

import "./AstronautGame.vue?vue&type=style&index=0&id=6d1d5586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1d5586"]])

export default __exports__